import axios from "axios";
import { getPaymentBaseurl } from "../_helpers";

const getAuthToken = () => JSON.parse(localStorage.getItem("token"));

const currentPath = window?.location?.href;

export const getCartItems = () => {
  return axios
    .get(`${getPaymentBaseurl(currentPath, true)}/v2/cart`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    })
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => console.log(error));
};

export const addCartItem = async (
  item,
  coupon,
  latitude,
  longitude,
  countryCode,
  bundle
) => {
  return await axios
    .post(
      `${getPaymentBaseurl(
        currentPath,
        true
      )}/v2/cart/${item}?country=${countryCode}&isBundle=${bundle ? 1 : 0}`,
      JSON.stringify({
        latitude: latitude,
        longitude: longitude,
        countryCode: countryCode,
        coupon: coupon,
      }),
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then(({ data }) => {
      return data;
    })
    .catch((error) => console.log(error));
};

export const updateCartService = (item, countryCode) => {
  return axios
    .put(
      `${getPaymentBaseurl(
        currentPath,
        true
      )}/v2/cart/${item}?country=${countryCode}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => console.log(error));
};

export const removeCartService = (item) => {
  return axios
    .delete(`${getPaymentBaseurl(currentPath, true)}/v2/cart/${item}`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => console.log(error));
};

export const clearCartService = () => {
  return axios
    .delete(`${getPaymentBaseurl(currentPath, true)}/v2/cart`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => console.log(error));
};

export const makePaymentService = (items) => {
  return axios
    .post(
      `${getPaymentBaseurl(currentPath, true)}/make-payment`,
      { courseList: items },
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data.data)
    .catch((error) => console.log(error));
};

export const chargeCardService = (
  token,
  sessionId,
  enterpriseStatus,
  changedSelectedPlan
) => {
  let url = enterpriseStatus
    ? `${getPaymentBaseurl(currentPath, false)}/charge-card-token`
    : `${getPaymentBaseurl(currentPath, true)}/charge-card-token`;
  return axios.post(
    url,
    enterpriseStatus
      ? changedSelectedPlan !== null
        ? {
            token: token,
            selectedPlan: changedSelectedPlan,
          }
        : {
            token: token,
          }
      : {
          token: token,
          sessionId: sessionId,
        },
    {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const verifyCheckoutService = (
  sessionId,
  countryCode,
  enterpriseStatus
) => {
  let url = enterpriseStatus
    ? `${getPaymentBaseurl(currentPath, false)}/razorpay-checkout`
    : `${getPaymentBaseurl(
        currentPath,
        true
      )}/v2/checkout?country=${countryCode}`;
  return axios

    .post(
      url,
      enterpriseStatus ? { id: sessionId } : { sessionId: sessionId },

      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then(({ data }) => {
      return data;
    })
    .catch((error) => console.log(error));
};

export const applyCoupon = (promoCode, courseId, countryCode) => {
  return axios.post(
    `${getPaymentBaseurl(currentPath, true)}/promoCode?country=${countryCode}`,
    {
      coupon: promoCode,
      courseId: courseId,
    },
    {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const handlePostWishlist = (courseId) => {
  return axios.post(
    `${getPaymentBaseurl(currentPath, true)}/wishlist/${courseId}`,
    {
      courseId: courseId,
    },
    {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const getWishlist = () => {
  return axios
    .get(`${getPaymentBaseurl(currentPath, true)}/wishlist`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    })
    .then((response) => response.data.data)
    .catch((error) => console.log(error));
};

export const handleDeleteWishlist = (courseId) => {
  return axios
    .delete(`${getPaymentBaseurl(currentPath, true)}/wishlist/${courseId}`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    })
    .then((response) => response.data.data)
    .catch((error) => console.log(error));
};

// export const removeCartItem = () => (dispatch) => {
//   return axios.put()
// }
